import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  journeys: {
    id: 'journey.journeys',
    description: 'Journeys Title',
    defaultMessage: 'Journeys',
  },
  unassignedLoadsTitle: {
    id: 'journey.nedLoadsTitle',
    description: 'Unassigned Loads Title',
    defaultMessage: 'Unassigned Loads',
  },
  newJourney: {
    id: 'journey.newJourney',
    description: 'New Journey',
    defaultMessage: 'New Journey',
  },
  addLeg: {
    id: 'journey.addLeg',
    description: 'Add Leg',
    defaultMessage: 'Add Leg',
  },
  saveDraft: {
    id: 'journey.saveDraft',
    description: 'Save Draft',
    defaultMessage: 'Save Draft',
  },
  reset: {
    id: 'journey.reset',
    description: 'Reset',
    defaultMessage: 'Reset',
  },
  cancel: {
    id: 'journey.cancel',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  approveForTransport: {
    id: 'journey.approveForTransport',
    description: 'Approve For Transport',
    defaultMessage: 'Approve For Transport',
  },
  journeyName: {
    id: 'journey.journey.name',
    description: 'Name of the journey',
    defaultMessage: 'Name',
  },
  journey: {
    id: 'journey.journey',
    description: 'Journey',
    defaultMessage: 'Journey',
  },
  legsName: {
    id: 'journey.legs.name',
    description: 'Name of the legs',
    defaultMessage: 'Legs',
  },
  customerName: {
    id: 'journey.customer.name',
    description: 'Name of the customer',
    defaultMessage: 'Customer',
  },
  consigneeName: {
    id: 'journey.consignee.name',
    description: 'Name of the consignee',
    defaultMessage: 'Consignee',
  },

  legName: {
    id: 'journey.leg.name',
    description: 'Name of the leg',
    defaultMessage: 'Leg',
  },
  routesName: {
    id: 'journey.routes.name',
    description: 'Name of the routes',
    defaultMessage: 'Routes',
  },
  loadsName: {
    id: 'journey.loads.name',
    description: 'Name of the loads',
    defaultMessage: 'Loads',
  },
  noLoadsSelected: {
    id: 'journey.noLoadsSelected',
    description: 'No Loads Selected',
    defaultMessage: 'No Loads Selected.',
  },
  createdOn: {
    id: 'journey.createdOn',
    description: 'Created On',
    defaultMessage: 'Created On',
  },
  editLink: {
    id: 'journey.editLink',
    description: 'Edit Link',
    defaultMessage: 'Edit',
  },
  viewLink: {
    id: 'journey.viewLink',
    description: 'View Link',
    defaultMessage: 'View',
  },
  routeName: {
    id: 'journey.route.name',
    description: 'Name of the route',
    defaultMessage: 'Route',
  },
  loadName: {
    id: 'journey.load.name',
    description: 'Name of the load',
    defaultMessage: 'Load',
  },
  carrierName: {
    id: 'journey.carrier.name',
    description: 'Name of the carrier',
    defaultMessage: 'Carrier',
  },
  pickupLocation: {
    id: 'journey.pickup.location',
    description: 'Pickup Location',
    defaultMessage: 'Pickup Location',
  },
  pickupDate: {
    id: 'journey.pickup.date',
    description: 'Pickup Date',
    defaultMessage: 'Pickup Date',
  },
  deliveryLocation: {
    id: 'journey.delivery.location',
    description: 'Delivery Location',
    defaultMessage: 'Delivery Location',
  },
  deliveryDate: {
    id: 'journey.delivery.date',
    description: 'Delivery Date',
    defaultMessage: 'Delivery Date',
  },
  idName: {
    id: 'journey.id.name',
    description: 'Name  of the id',
    defaultMessage: 'Id',
  },
  statusName: {
    id: 'journey.status.name',
    description: 'Name of the status',
    defaultMessage: 'Status',
  },
  transportModeName: {
    id: 'journey.transportMode.name',
    description: 'Transport Mode column header',
    defaultMessage: 'Transport Mode',
  },
  approvedStatus: {
    id: 'journey.approvedStatus',
    description: 'Approved',
    defaultMessage: 'Approved',
  },
  draftStatus: {
    id: 'journey.draftStatus',
    description: 'Draft',
    defaultMessage: 'Draft',
  },
  trackingNumber: {
    id: 'journey.trackingNumber',
    description: 'Tracking Number',
    defaultMessage: 'Tracking Number',
  },
  quantity: {
    id: 'journey.quantity',
    description: 'Quantity',
    defaultMessage: 'Quantity',
  },
  isHazardous: {
    id: 'journey.isHazardous',
    description: 'Is Hazardous',
    defaultMessage: 'Hazardous',
  },
  value: {
    id: 'journey.value',
    description: 'Value',
    defaultMessage: 'Value',
  },
  containerNumber: {
    id: 'journey.containerNumber',
    description: 'Container Number',
    defaultMessage: 'Container Number',
  },
  description: {
    id: 'journey.description',
    description: 'Description',
    defaultMessage: 'Description',
  },
  temperatureRange: {
    id: 'journey.temperatureRange',
    description: 'Temperature Range',
    defaultMessage: 'Temperature Range',
  },
  journeyType: {
    id: 'journeyType',
    description: 'Journey Type',
    defaultMessage: 'Journey Type',
  },
  selectTypeOfJourney: {
    id: 'journey.selectTypeOfJourney',
    description: 'Select Type Of Journey',
    defaultMessage: 'Please select the type of journey you want to create',
  },
  withLoad: {
    id: 'journey.withLoad',
    description: 'With Load',
    defaultMessage: 'With Load',
  },
  createJourney: {
    id: 'journey.createJourney',
    description: 'Create Journey',
    defaultMessage: 'Create Journey',
  },
  standardJourney: {
    id: 'journey.standardJourney',
    description: 'Standard Journey',
    defaultMessage: 'Standard Journey',
  },
  multiModalJourney: {
    id: 'journey.multiModalJourney',
    description: 'Multimodal Journey',
    defaultMessage: 'Multimodal Journey',
  },
  withoutLoad: {
    id: 'journey.withoutLoad',
    description: 'Without Load',
    defaultMessage: 'Without Load',
  },
  journeyConfiguration: {
    id: 'journey.journeyConfiguration',
    description: 'Journey Configuration',
    defaultMessage: 'Please select Journey Configuration',
  },
  legOrigin: {
    id: 'journey.leg.origin',
    description: 'Middle Leg - Origin',
    defaultMessage: 'Middle Leg - Origin',
  },
  legDestination: {
    id: 'journey.leg.destination',
    description: 'Middle Leg - Destination',
    defaultMessage: 'Middle Leg - Destination',
  },
  selectLoads: {
    id: 'journey.selectLoads',
    description: 'Select Loads',
    defaultMessage: 'Select Loads',
  },
  addLoads: {
    id: 'journey.addLoads',
    description: 'Add Loads',
    defaultMessage: 'Add Loads',
  },
  cannotCombineLoadsAndAssets: {
    id: 'journey.cannotCombineLoadsAndAssets',
    defaultMessage: 'You cannot combine shipment loads and asset requests in the same journey',
    description:
      'Error message when attempting to combine shipment loads and asset requests in the same journey.',
  },
  noSelectedLoadsWarning: {
    id: 'journey.noSelectedLoadsWarning',
    defaultMessage:
      'You have not selected any loads. Are you sure you wish to create a Journey without loads?',
    description: 'Warning message when attempting to create a journey without selecting any loads.',
  },
  addRoute: {
    id: 'journey.addRoute',
    description: 'Add Route',
    defaultMessage: 'Add Route',
  },
  legCarrierLabel: {
    id: 'journey.legCarrierLabel',
    description: 'Leg Carrier Label',
    defaultMessage: 'Carrier',
  },
  legCarrierWaybillMaster: {
    id: 'journey.legCarrierWaybillMaster',
    description: 'Leg Carrier Waybill Master',
    defaultMessage: 'Carrier Waybill Master',
  },
  selectLocation: {
    id: 'journey.selectLocation',
    description: 'Select Location',
    defaultMessage: 'Select Location',
  },
  start: {
    id: 'journey.start',
    description: 'Start',
    defaultMessage: 'Start',
  },
  end: {
    id: 'journey.end',
    description: 'End',
    defaultMessage: 'End',
  },
  stop: {
    id: 'journey.stop',
    description: 'Stop',
    defaultMessage: 'Stop {stopNumber}',
  },
  selectContact: {
    id: 'journey.selectContact',
    description: 'Select Contact',
    defaultMessage: 'Select Contact',
  },
  pickup: {
    id: 'journey.pickup',
    description: 'Pickup',
    defaultMessage: 'Pickup',
  },
  dropoff: {
    id: 'journey.dropoff',
    description: 'Dropoff',
    defaultMessage: 'Dropoff',
  },
  removeLoadFromRoute: {
    id: 'journey.removeLoadFromRoute',
    description: 'Remove Load From Route',
    defaultMessage: 'Remove Load From Route',
  },
  noLoads: {
    id: 'journey.noLoads',
    description: 'No Loads',
    defaultMessage: 'No Loads',
  },
  journeyNotSaved: {
    id: 'journey.journeyNotSaved',
    description: 'Journey Not Saved',
    defaultMessage: 'Journey not saved',
  },
  journeyNotApproved: {
    id: 'journey.journeyNotApproved',
    description: 'Journey Not Approved',
    defaultMessage: 'Journey not approved',
  },
  journeyApprovedSuccessfully: {
    id: 'journey.journeyApprovedSuccessfully',
    description: 'Journey Approved Successfully',
    defaultMessage: 'Journey approved successfully',
  },
  journeySavedSuccessfully: {
    id: 'journey.journeySavedSuccessfully',
    description: 'Journey Saved Successfully',
    defaultMessage: 'Journey saved successfully',
  },
  loadPickupDeliveryValidation: {
    id: 'journey.loadPickupDeliveryValidation',
    description: 'Load Pickup Delivery Validation',
    defaultMessage: 'Pickup location must be before delivery location',
  },
  loadPickupDeliveryLegsValidation: {
    id: 'journey.loadPickupDeliveryLegsValidation',
    description: 'Load Pickup Delivery Legs Validation',
    defaultMessage: 'Load pickup location must be before leg delivery location',
  },
  loadPickupDropoffValidation: {
    id: 'journey.loadPickupDropoffValidation',
    description: 'Load Pickup Dropoff Validation',
    defaultMessage: 'Pickup location must be before dropoff location',
  },
  invalidRouteLocationCount: {
    id: 'journey.invalidRouteLocationCount',
    description: 'Invalid Route Location Count',
    defaultMessage: 'A route must have at least two locations',
  },
  type: {
    id: 'journey.type',
    description: 'Type',
    defaultMessage: 'Type',
  },
  temperatureControlled: {
    id: 'journey.temperatureControlled',
    description: 'Temperature Controlled',
    defaultMessage: 'Temperature Controlled',
  },
  shipFrom: {
    id: 'journey.shipFrom',
    description: 'Ship From',
    defaultMessage: 'Ship From',
  },
  waypoints: {
    id: 'journey.waypoints',
    description: 'Waypoints',
    defaultMessage: 'Waypoints',
  },
  deliverTo: {
    id: 'journey.deliverTo',
    description: 'Deliver To',
    defaultMessage: 'Deliver To',
  },
  customer: {
    id: 'journey.customer',
    description: 'Customer',
    defaultMessage: 'Customer',
  },
  waypoint: {
    id: 'journey.waypoint',
    description: 'Waypoint',
    defaultMessage: 'Waypoint',
  },
  location: {
    id: 'journey.location',
    description: 'Location',
    defaultMessage: 'Location',
  },
  contact: {
    id: 'journey.contact',
    description: 'Contact',
    defaultMessage: 'Contact',
  },
  specialInstructions: {
    id: 'journey.specialInstructions',
    description: 'Special Instructions',
    defaultMessage: 'Special Instructions',
  },
  clearingRequired: {
    id: 'journey.clearingRequired',
    description: 'Clearing Required',
    defaultMessage: 'Clearing Required',
  },
  services: {
    id: 'journey.services',
    description: 'Services',
    defaultMessage: 'Services',
  },
  modeOfTransit: {
    id: 'journey.modeOfTransit',
    description: 'Mode of Transit',
    defaultMessage: 'Mode of Transit',
  },
  crossBorder: {
    id: 'journey.crossBorder',
    description: 'Cross Border',
    defaultMessage: 'Cross Border',
  },
  fulfilmentRequired: {
    id: 'journey.fulfilmentRequired',
    description: 'Fulfilment Req.',
    defaultMessage: 'Fulfilment Req.',
  },
  preferredCarrier: {
    id: 'journey.preferredCarrier',
    description: 'Preferred Carrier',
    defaultMessage: 'Preferred Carrier',
  },
  preBookedTransitIdentifier: {
    id: 'journey.preBookedTransitIdentifier',
    description: 'Pre-booked Transit Identifier',
    defaultMessage: 'Pre-booked Transit Identifier',
  },
  scheduledDeparture: {
    id: 'journey.scheduledDeparture',
    description: 'Sched. Departure',
    defaultMessage: 'Sched. Departure',
  },
  scheduledArrival: {
    id: 'journey.scheduledArrival',
    description: 'Sched. Arrival',
    defaultMessage: 'Sched. Arrival',
  },
  yes: {
    id: 'journey.yes',
    description: 'Yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'journey.no',
    description: 'No',
    defaultMessage: 'No',
  },
  notAvailable: {
    id: 'journey.notAvailable',
    description: 'N/A',
    defaultMessage: 'N/A',
  },
  planJourney: {
    id: 'journey.planJourney',
    description: 'Plan Journey',
    defaultMessage: 'Plan Journey',
  },
  loadsSelected: {
    id: 'journey.loadsSelected',
    description: 'Loads Selected',
    defaultMessage: '{count} load(s) selected',
  },
  selectedOfTotal: {
    id: 'journey.selectedOfTotal',
    description: 'Selected of Total',
    defaultMessage: '{selected}/{total}',
  },
  selected: {
    id: 'journey.selected',
    description: 'Selected',
    defaultMessage: 'Selected',
  },
  consignmentInformation: {
    id: 'journey.consignmentInformation',
    description: 'Consignment Information',
    defaultMessage: 'Consignment Information',
  },
  consignmentType: {
    id: 'journey.consignmentType',
    description: 'Consignment Type',
    defaultMessage: 'Consignment Type',
  },
  shipper: {
    id: 'journey.shipper',
    description: 'Shipper',
    defaultMessage: 'Shipper',
  },
  currency: {
    id: 'journey.currency',
    description: 'Currency',
    defaultMessage: 'Currency',
  },
  referenceNumber: {
    id: 'journey.referenceNumber',
    description: 'Reference Number',
    defaultMessage: 'Reference Number',
  },
  loads: {
    id: 'journey.loads',
    description: 'Loads',
    defaultMessage: 'Loads',
  },
  numberOfLoads: {
    id: 'journey.numberOfLoads',
    description: 'Number of Loads',
    defaultMessage: 'Number of Loads',
  },
  serviceWaypoint: {
    id: 'journey.serviceWaypoint',
    description: 'Service Waypoint',
    defaultMessage: 'Service Waypoint',
  },
  service: {
    id: 'journey.service',
    description: 'Service',
    defaultMessage: 'Service',
  },
  loadType: {
    id: 'journey.loadType',
    description: 'Load Type',
    defaultMessage: 'Load Type',
  },
  tempRange: {
    id: 'journey.tempRange',
    description: 'Temp Range',
    defaultMessage: 'Temp Range',
  },
  contents: {
    id: 'journey.contents',
    description: 'Contents',
    defaultMessage: 'Contents',
  },
  loadInformation: {
    id: 'journey.loadInformation',
    description: 'Load Information',
    defaultMessage: 'Load Information',
  },
  productDescription: {
    id: 'journey.productDescription',
    description: 'Product Description',
    defaultMessage: 'Product Description',
  },
  unitPrice: {
    id: 'journey.unitPrice',
    description: 'Unit Price',
    defaultMessage: 'Unit Price',
  },
  total: {
    id: 'journey.total',
    description: 'Total',
    defaultMessage: 'Total',
  },
  countryOfOrigin: {
    id: 'journey.countryOfOrigin',
    description: 'Country of Origin',
    defaultMessage: 'Country of Origin',
  },
  view: {
    id: 'journey.view',
    description: 'View',
    defaultMessage: 'view',
  },
  totalValue: {
    id: 'journey.totalValue',
    description: 'Total Value',
    defaultMessage: 'Total Value',
  },
  containsHazardousMaterials: {
    id: 'journey.containsHazardousMaterials',
    description: 'Contains Hazardous Materials',
    defaultMessage: 'Contains Hazardous Materials',
  },
  noContents: {
    id: 'journey.noContents',
    description: 'No Contents',
    defaultMessage: 'No Contents',
  },
  errorLoadingData: {
    id: 'journey.errorLoadingData',
    description: 'Error Loading Data',
    defaultMessage: 'Error loading data',
  },
  contentDetails: {
    id: 'journey.contentDetails',
    description: 'Content Details',
    defaultMessage: 'Content Details',
  },
  contentInformation: {
    id: 'journey.contentInformation',
    description: 'Content Information',
    defaultMessage: 'Content Information',
  },
  physicalProperties: {
    id: 'journey.physicalProperties',
    description: 'Physical Properties',
    defaultMessage: 'Physical Properties',
  },
  netWeight: {
    id: 'journey.netWeight',
    description: 'Net Weight',
    defaultMessage: 'Net Weight',
  },
  grossWeight: {
    id: 'journey.grossWeight',
    description: 'Gross Weight',
    defaultMessage: 'Gross Weight',
  },
  volume: {
    id: 'journey.volume',
    description: 'Volume',
    defaultMessage: 'Volume',
  },
  length: {
    id: 'journey.length',
    description: 'Length',
    defaultMessage: 'Length',
  },
  diameter: {
    id: 'journey.diameter',
    description: 'Diameter',
    defaultMessage: 'Diameter',
  },
  width: {
    id: 'journey.width',
    description: 'Width',
    defaultMessage: 'Width',
  },
  height: {
    id: 'journey.height',
    description: 'Height',
    defaultMessage: 'Height',
  },
  hsCodes: {
    id: 'journey.hsCodes',
    description: 'HS Codes',
    defaultMessage: 'HS Codes',
  },
  hsHeading: {
    id: 'journey.hsHeading',
    description: 'HS Heading',
    defaultMessage: 'HS Heading',
  },
  hsSubheading: {
    id: 'journey.hsSubheading',
    description: 'HS Subheading',
    defaultMessage: 'HS Subheading',
  },
  temperatureSettings: {
    id: 'journey.temperatureSettings',
    description: 'Temperature Settings',
    defaultMessage: 'Temperature Settings',
  },
  setPoint: {
    id: 'journey.setPoint',
    description: 'Set Point',
    defaultMessage: 'Set Point',
  },
  upperThresholdWarning: {
    id: 'journey.upperThresholdWarning',
    description: 'Upper Threshold Warning',
    defaultMessage: 'Upper Threshold Warning',
  },
  upperThresholdCritical: {
    id: 'journey.upperThresholdCritical',
    description: 'Upper Threshold Critical',
    defaultMessage: 'Upper Threshold Critical',
  },
  lowerThresholdWarning: {
    id: 'journey.lowerThresholdWarning',
    description: 'Lower Threshold Warning',
    defaultMessage: 'Lower Threshold Warning',
  },
  lowerThresholdCritical: {
    id: 'journey.lowerThresholdCritical',
    description: 'Lower Threshold Critical',
    defaultMessage: 'Lower Threshold Critical',
  },
  journeyPlanner: {
    id: 'journey.journeyPlanner',
    description: 'Journey Planner',
    defaultMessage: 'Journey Planner',
  },
  noLoadsSelectedForPlanning: {
    id: 'journey.noLoadsSelectedForPlanning',
    description: 'No loads selected for planning message',
    defaultMessage: 'No loads have been selected for planning. Please go back to Unassigned Loads and select loads first.',
  },
  backToUnassignedLoads: {
    id: 'journey.backToUnassignedLoads',
    description: 'Back to Unassigned Loads',
    defaultMessage: 'Back to Unassigned Loads',
  },
  transitIdentifier: {
    id: 'journey.transitIdentifier',
    description: 'Transit Identifier',
    defaultMessage: 'Transit Identifier',
  },
  fulfilmentNotRequired: {
    id: 'journey.fulfilmentNotRequired',
    description: 'Fulfilment NOT Required',
    defaultMessage: 'Fulfilment NOT Required',
  },
  action: {
    id: 'journey.action',
    description: 'Action',
    defaultMessage: 'Action',
  },
  destination: {
    id: 'journey.destination',
    description: 'Destination',
    defaultMessage: 'Destination',
  },
  selectTransportMode: {
    id: 'journey.selectTransportMode',
    description: 'Select Transport Mode',
    defaultMessage: 'Select Transport Mode',
  },
  selectCarrier: {
    id: 'journey.selectCarrier',
    description: 'Select Carrier',
    defaultMessage: 'Select Carrier',
  },
  road: {
    id: 'journey.road',
    description: 'Road',
    defaultMessage: 'Road',
  },
  sea: {
    id: 'journey.sea',
    description: 'Sea',
    defaultMessage: 'Sea',
  },
  air: {
    id: 'journey.air',
    description: 'Air',
    defaultMessage: 'Air',
  },
  rail: {
    id: 'journey.rail',
    description: 'Rail',
    defaultMessage: 'Rail',
  },
  saveJourney: {
    id: 'journey.saveJourney',
    description: 'Save Journey',
    defaultMessage: 'Save Journey',
  },
  legNumber: {
    id: 'journey.legNumber',
    description: 'Leg Number',
    defaultMessage: 'Leg #{number}',
  },
  routeNumber: {
    id: 'journey.routeNumber',
    description: 'Route Number',
    defaultMessage: 'Route #{number}',
  },
  journeySaveFailed: {
    id: 'journey.journeySaveFailed',
    description: 'Failed to save journey',
    defaultMessage: 'Failed to save journey. Please try again.',
  },
  addDestination: {
    id: 'journey.addDestination',
    description: 'Add Destination',
    defaultMessage: 'Add Destination',
  },
  removeLeg: {
    id: 'journey.removeLeg',
    description: 'Remove Leg',
    defaultMessage: 'Remove Leg',
  },
  removeRoute: {
    id: 'journey.removeRoute',
    description: 'Remove Route',
    defaultMessage: 'Remove Route',
  },
  removeDestination: {
    id: 'journey.removeDestination',
    description: 'Remove Destination',
    defaultMessage: 'Remove Destination',
  },
  waypointNumber: {
    id: 'journey.waypointNumber',
    description: 'Waypoint Number',
    defaultMessage: 'Waypoint #{number}',
  },
  addWaypoint: {
    id: 'journey.addWaypoint',
    description: 'Add Waypoint',
    defaultMessage: 'Add Waypoint',
  },
  addWaypointBefore: {
    id: 'journey.addWaypointBefore',
    description: 'Add Waypoint Before',
    defaultMessage: 'Add Waypoint Before',
  },
  addWaypointAfter: {
    id: 'journey.addWaypointAfter',
    description: 'Add Waypoint After',
    defaultMessage: 'Add Waypoint After',
  },
  address: {
    id: 'journey.address',
    description: 'Address',
    defaultMessage: 'Address',
  },
  merge: {
    id: 'journey.merge',
    description: 'Merge',
    defaultMessage: 'Merge',
  },
  split: {
    id: 'journey.split',
    description: 'Split',
    defaultMessage: 'Split',
  },
  date: {
    id: 'journey.date',
    description: 'Date',
    defaultMessage: 'Date',
  },
  add: {
    id: 'journey.add',
    description: 'Add',
    defaultMessage: 'Add',
  },
  legTransportMode: {
    id: 'journey.legTransportMode',
    description: 'Leg Transport Mode',
    defaultMessage: 'Leg Transport Mode',
  },
  whichLegToRemove: {
    id: 'journey.whichLegToRemove',
    description: 'Which leg to remove dialog message',
    defaultMessage: 'Which leg do you want to remove with this Waypoint?',
  },
  removeLegNumber: {
    id: 'journey.removeLegNumber',
    description: 'Remove Leg Number',
    defaultMessage: 'Remove Leg #{number}',
  },
  splitRoute: {
    id: 'journey.splitRoute',
    description: 'Split Route',
    defaultMessage: 'Split Route',
  },
  splitRouteConfirmation: {
    id: 'journey.splitRouteConfirmation',
    description: 'Split Route Confirmation Question',
    defaultMessage: 'How do you want the selected consignments to be split?',
  },
  oneRoutePerConsignment: {
    id: 'journey.oneRoutePerConsignment',
    description: 'One Route Per Consignment',
    defaultMessage: 'One Route Per Consignment',
  },
  oneRouteForAllConsignments: {
    id: 'journey.oneRouteForAllConsignments',
    description: 'One Route For All Consignments',
    defaultMessage: 'One Route For All Consignments',
  },
  consignment: {
    id: 'journey.consignment',
    description: 'Consignment',
    defaultMessage: 'Consignment',
  },
  tempControlled: {
    id: 'journey.tempControlled',
    description: 'Temp. Controlled',
    defaultMessage: 'Temp. Controlled',
  },
  mergeRoute: {
    id: 'journey.mergeRoute',
    description: 'Merge Route',
    defaultMessage: 'Merge Route',
  },
  selectRoutesToMerge: {
    id: 'journey.selectRoutesToMerge',
    description: 'Select Routes to Merge',
    defaultMessage: 'Select at least two routes to merge',
  },
  routesSelectedForMerge: {
    id: 'journey.routesSelectedForMerge',
    description: 'Routes Selected for Merge',
    defaultMessage: '{count} route(s) selected',
  },
  routes: {
    id: 'journey.routes',
    description: 'Routes',
    defaultMessage: 'Routes',
  },
  noConsignments: {
    id: 'journey.noConsignments',
    description: 'No Consignments',
    defaultMessage: 'No consignments',
  },
  customerRequests: {
    id: 'journey.customerRequests',
    description: 'Customer Requests',
    defaultMessage: 'Customer Requests',
  },
  selectDestination: {
    id: 'journey.selectDestination',
    description: 'Select Destination',
    defaultMessage: 'Select Destination',
  },
  selectServices: {
    id: 'journey.selectServices',
    description: 'Select Services',
    defaultMessage: 'Select Services',
  },
  pickUpDropOff: {
    id: 'journey.pickUpDropOff',
    description: 'Pick-Up/Drop-Off',
    defaultMessage: 'Pick-Up/Drop-Off',
  },
  clearance: {
    id: 'journey.clearance',
    description: 'Clearance',
    defaultMessage: 'Clearance',
  },
  selectedServices: {
    id: 'journey.selectedServices',
    description: 'Selected Services',
    defaultMessage: 'Selected Services',
  },
  returnLocation: {
    id: 'journey.returnLocation',
    description: 'Return Location',
    defaultMessage: 'Return Location',
  },
  noServicesSelected: {
    id: 'journey.noServicesSelected',
    description: 'No services selected',
    defaultMessage: 'No services selected',
  },
  selectAService: {
    id: 'journey.selectAService',
    description: 'Select a service',
    defaultMessage: 'Select a service',
  },
  scheduledDate: {
    id: 'journey.scheduledDate',
    description: 'Scheduled Date',
    defaultMessage: 'Scheduled Date',
  },
  editActionsServices: {
    id: 'journey.editActionsServices',
    description: 'Edit Actions/Services',
    defaultMessage: 'Edit Actions/Services',
  },
  load: {
    id: 'journey.load',
    description: 'Load',
    defaultMessage: 'Load',
  },
  removeLoadFromDestination: {
    id: 'journey.removeLoadFromDestination',
    description: 'Remove load from destination',
    defaultMessage: 'Remove load from destination',
  },
  save: {
    id: 'journey.save',
    description: 'Save',
    defaultMessage: 'Save',
  },
  editActionsServicesDescription: {
    id: 'journey.editActionsServicesDescription',
    description: 'Edit actions and services for loads at this destination',
    defaultMessage: 'Edit actions and services for loads at this destination',
  },
  noLoadActionsAtDestination: {
    id: 'journey.noLoadActionsAtDestination',
    description: 'No load actions at this destination',
    defaultMessage: 'No load actions at this destination',
  },
  addService: {
    id: 'journey.addService',
    description: 'Add Service',
    defaultMessage: 'Add Service',
  },
  actions: {
    id: 'journey.actions',
    description: 'Actions',
    defaultMessage: 'Actions',
  },
  noServicesAssigned: {
    id: 'journey.noServicesAssigned',
    description: 'No Services Assigned',
    defaultMessage: 'No services assigned to this consignment',
  },
  serviceAtLocation: {
    id: 'journey.serviceAtLocation',
    description: 'Service at Location header format',
    defaultMessage: '{location} - {service}',
  },
  home: {
    id: 'journey.home',
    description: 'Home breadcrumb',
    defaultMessage: 'Home',
  },
  shipping: {
    id: 'journey.shipping',
    description: 'Shipping breadcrumb',
    defaultMessage: 'Shipping',
  },
  consignments: {
    id: 'journey.consignments',
    description: 'Consignments section title',
    defaultMessage: 'Consignments',
  },
  transitDetails: {
    id: 'journey.transitDetails',
    description: 'Transit Details section title',
    defaultMessage: 'Transit Details',
  },
  noWaypointDetails: {
    id: 'journey.noWaypointDetails',
    description: 'No waypoint details available message',
    defaultMessage: 'No waypoint details available.',
  },
  noRoutes: {
    id: 'journey.noRoutes',
    description: 'No routes available message',
    defaultMessage: 'No routes available.',
  },
  noDestinations: {
    id: 'journey.noDestinations',
    description: 'No destinations available message',
    defaultMessage: 'No destinations available.',
  },
})
